import { CircularProgress, Grid } from "@mui/material";

export const Loader = () => (
    <Grid
        alignContent="center"
        flexDirection="column"
        height="100vh"
        justifyContent="center"
        container
    >
        <CircularProgress />
    </Grid>
);
